<div class="cursor" #cursor>
  <img src="/cursor.webp" class="acacia-cursor" alt="">
</div>
